"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Self = void 0;
const StaffUserType_1 = __importDefault(require("@opsbase/lib-auth/StaffUserType"));
const UserPreferences_1 = __importDefault(require("@opsbase/lib-auth/UserPreferences"));
const VisaType_1 = __importDefault(require("@opsbase/lib-auth/VisaType"));
const OrgSettings_1 = __importDefault(require("@opsbase/lib-org/OrgSettings"));
const AccessTo_1 = __importDefault(require("../AccessTo"));
class Self {
    constructor() {
        this.id = '';
        this.visaType = VisaType_1.default.GUEST;
        this.userType = StaffUserType_1.default.EMPLOYEE;
        this.enabled = true;
        this.pushEnabled = false;
        this.email = '';
        this.hasProfileImage = false;
        this.profileImageUrl = undefined;
        this.organisationTitle = '';
        this.isOrgSetup = false;
        this.zenDeskJWTToken = '';
        this.multiOrg = false;
        this.settings = new OrgSettings_1.default();
        this.preferences = new UserPreferences_1.default();
        this.features = [];
        this.selfieRequired = false;
        this.showStaffIssues = false;
        this.accessiblePlaces = AccessTo_1.default.None();
        this.accessibleTeams = AccessTo_1.default.None();
        this.accessiblePositions = AccessTo_1.default.None();
        this.allowedOrgIds = [];
        this.allowedOrgTags = [];
    }
    get isSignedIn() {
        return this.isSuperUser || this.isStaff || this.isTeamboard;
    }
    get isOrgFocused() {
        return !!this.organisationId;
    }
    get isSuperUser() {
        return this.visaType === VisaType_1.default.SUPERUSER;
    }
    get isPrimary() {
        return this.isStaff && this.userType === StaffUserType_1.default.PRIMARYADMIN;
    }
    get isAdmin() {
        return this.isStaff && this.userType === StaffUserType_1.default.ADMIN;
    }
    get isEmployee() {
        return this.isStaff && this.userType === StaffUserType_1.default.EMPLOYEE;
    }
    get isStaff() {
        return this.visaType === VisaType_1.default.STAFF;
    }
    get isTeamboard() {
        return this.visaType === VisaType_1.default.TEAMBOARD;
    }
    static fromCompressedData(self) {
        if (!self)
            return undefined;
        try {
            return Self.fromData(JSON.parse(self || '{}'));
        }
        catch (_a) {
            return undefined;
        }
    }
    static fromData(data = {}) {
        const self = new Self();
        if (data === null || data === void 0 ? void 0 : data.id)
            self.id = data.id;
        if (data === null || data === void 0 ? void 0 : data.visaType)
            self.visaType = data.visaType;
        if (data === null || data === void 0 ? void 0 : data.userType)
            self.userType = data.userType;
        if (data === null || data === void 0 ? void 0 : data.organisationId)
            self.organisationId = data.organisationId;
        if (data === null || data === void 0 ? void 0 : data.title)
            self.title = data.title;
        if (data === null || data === void 0 ? void 0 : data.email)
            self.email = data.email;
        if (data === null || data === void 0 ? void 0 : data.isOrgSetup)
            self.isOrgSetup = data.isOrgSetup;
        if (data === null || data === void 0 ? void 0 : data.selfieRequired)
            self.selfieRequired = data.selfieRequired;
        if (data === null || data === void 0 ? void 0 : data.showStaffIssues)
            self.showStaffIssues = data.showStaffIssues;
        if (data === null || data === void 0 ? void 0 : data.hasProfileImage)
            self.hasProfileImage = data.hasProfileImage;
        if (data === null || data === void 0 ? void 0 : data.profileImageUrl)
            self.profileImageUrl = data.profileImageUrl;
        if (data === null || data === void 0 ? void 0 : data.organisationTitle)
            self.organisationTitle = data.organisationTitle;
        if (data === null || data === void 0 ? void 0 : data.zenDeskJWTToken)
            self.zenDeskJWTToken = data.zenDeskJWTToken;
        if (data === null || data === void 0 ? void 0 : data.hasOwnProperty('selfieRequired'))
            self.selfieRequired = data.selfieRequired;
        if (data === null || data === void 0 ? void 0 : data.hasOwnProperty('showStaffIssues'))
            self.showStaffIssues = data.showStaffIssues;
        if (data === null || data === void 0 ? void 0 : data.multiOrg)
            self.multiOrg = data.multiOrg;
        if (data === null || data === void 0 ? void 0 : data.settings)
            self.settings = new OrgSettings_1.default(data.settings);
        if (data === null || data === void 0 ? void 0 : data.preferences)
            self.preferences = new UserPreferences_1.default(data.preferences);
        if (data === null || data === void 0 ? void 0 : data.features)
            self.features = data.features;
        if (data === null || data === void 0 ? void 0 : data.accessiblePlaces)
            self.accessiblePlaces = new AccessTo_1.default(data.accessiblePlaces.items, data.accessiblePlaces.all);
        if (data === null || data === void 0 ? void 0 : data.accessibleTeams)
            self.accessibleTeams = new AccessTo_1.default(data.accessibleTeams.items, data.accessibleTeams.all);
        if (data === null || data === void 0 ? void 0 : data.accessiblePositions)
            self.accessiblePositions = new AccessTo_1.default(data.accessiblePositions.items, data.accessiblePositions.all);
        if (data === null || data === void 0 ? void 0 : data.allowedOrgTags)
            self.allowedOrgTags = data.allowedOrgTags;
        if (data === null || data === void 0 ? void 0 : data.allowedOrgIds)
            self.allowedOrgIds = data.allowedOrgIds;
        if (data === null || data === void 0 ? void 0 : data.allowedOrgs)
            self.allowedOrgIds = data.allowedOrgs.map(z => z.id);
        return self;
    }
}
exports.Self = Self;
exports.default = Self;
